import React from "react";
import { Button, Card, Form, Icon } from "semantic-ui-react";
import useAgcCheck from "@common/components/hooks/useAgcCheck";
import ToggleButtons from "@common/components/shared/forms/ToggleButtons";
import NumberInputComponent from "@common/components/shared/forms/NumberInputComponent";
import useLogin from "@common/components/hooks/useLogin";
import { getDatePart, getTimePart } from "../helpers/datetime";

const AgcCheckForm = () => {
  const {
    user,
    isDesktop,
    name,
    filteredQuestions,
    scanResult,
    showScanner,
    timeChecked,
    handleAnswers,
    onSubmit,
  } = useAgcCheck();
  const [{ isInReadMode }] = useLogin();

  return (
    <Form className="p-1" onSubmit={onSubmit}>
      <Card className="w-100">
        <Card.Content>
          <Card.Header>
            <b>Scan Summary:</b>
          </Card.Header>
        </Card.Content>
        <Card.Content>
          <p className="text-m">
            User: <b>{isDesktop ? user : name}</b>
          </p>
          <p className="text-m">
            Site Code: <b>{scanResult.siteCode}</b>
          </p>
          <p className="text-m">
            Location: <b>{scanResult.location}</b>
          </p>
          <p className="text-m">
            Time of check:{" "}
            <b>
              {getDatePart(timeChecked)}, {getTimePart(timeChecked)}
            </b>
          </p>
        </Card.Content>
      </Card>
      <Card className="w-100">
        <Card.Content>
          <Card.Header>
            <b>Questions:</b>
          </Card.Header>
        </Card.Content>
        <Card.Content>
          {filteredQuestions.map((x) =>
            x.id !== 5 ? (
              <ToggleButtons
                key={x.id}
                value={x.value}
                onToggle={(value) => handleAnswers(x.id, value)}
                label={x.label}
              />
            ) : (
              <NumberInputComponent
                key={x.id}
                name={x.name}
                value={x.value}
                onChange={(value) => handleAnswers(x.id, value)}
                label={x.label}
                type="number"
                labelClass="w-50"
              />
            ),
          )}
        </Card.Content>
      </Card>
      <Button
        fluid
        className="my-2"
        color="blue"
        type="submit"
        disabled={
          isInReadMode ||
          !scanResult ||
          filteredQuestions.some((x) => x.value === null)
        }
      >
        {!isDesktop && <Icon name="camera" />}
        {isDesktop ? "Save " : "Confirm "}
        AGC Check
      </Button>
      {!isDesktop && !isInReadMode && (
        <Button fluid className="my-2" type="button" onClick={showScanner}>
          <Icon name="camera" />
          Re-Scan QR Code
        </Button>
      )}
    </Form>
  );
};

export default AgcCheckForm;
